import tableTemplate from './reactStatementsMainTable.html';
import { reactStatementsCols, defaultSortModel } from './statementsColDefs';
import {ReactTableController} from "../reactTableController";
import {statementOptions} from "../../../views/administration/userReports/UserReportDetailDialogController";
import {BackendService} from "../../../services/BackendService";
import {statements, VALUES} from "../../../services/arsweb/RoutingPaths";
import {STATEMENT_DETAIL_ROUTE} from "../../../controller/StatementController";
import {REPORT_TYPE} from "../../../components/report/ReportModalController";

/** @ngInject */
export function reactStatementsMainTable() {
    return {
        restrict: 'E',
        scope: {
            filter: '=',
            subFilter: '=',
            tableId: '@',
            height: '@',
            selectedKey: '@',
            withSelection: '=',
            parentController: '=',
            selectedAccounts: '=',
            hideColumns: '='
        },
        templateUrl: tableTemplate,
        controller: ReactStatementsMainTableController,
        controllerAs: 'statementsMainTableController'
    };
}

/** @ngInject */
export class ReactStatementsMainTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {

        super($scope, userService, arsMainDependencies, STATEMENT_DETAIL_ROUTE, new BackendService(userService), statements + VALUES,
            "STATEMENTS", 'statementsMainTableParams', "statementID", false, statementOptions, defaultSortModel);
        this.isUserReport = false;
        statementOptions.withLastAndUnread = false;
        statementOptions.withDateRange = false;
        this.backendService.service.config.params.filter = {};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));

        const parentOnReport = this.defaultReactGridParams.onReport;
        this.defaultReactGridParams.onReport = (selectedNodes) => {
            this.updateReportTypesForSelection();
            parentOnReport.call(this, selectedNodes);
        };
    }

    initGrid(userService) {

        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactStatementsCols(this.translate, userService);
			this.initCols();
            // react gridParameters for account table
            const statementsGridParams = {
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency'},
                url: this.backendService.service.getServiceUrl(statements + VALUES),
                onCellClicked: (row) => {
                    this.state.params.id = row.data.account.accountName;
                    this.showChildDetailsView(row.data[this.rowNodeID])
                }};

            this.reactGridParams = {...this.defaultReactGridParams, ...statementsGridParams};
        });
    }

    updateReportTypesForSelection() {
        // Remove previous CAMT053 if present
        statementOptions.options = statementOptions.options.filter(opt =>
            opt !== REPORT_TYPE.CAMT053_STATEMENTS
        );
        // Add CAMT053 if flag is true
        if (this.getCamt05xFlag()) {
            statementOptions.options.push(REPORT_TYPE.CAMT053_STATEMENTS);
        }
    }
}
